import { DashboardAuthCallbackPage } from "@dashboard/components/DashboardAuthCallbackPage"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/auth/callback")({
  component: DashboardAuthCallbackPage,
})
